module.exports = __webpack_public_path__ + "img/3O.837c985f.png";